/**
 * Discord API module
 */
import { coreClient, apiRequest } from '../client.js';
import type { DiscordGuild, DiscordMember, DiscordChannel } from '../types.js';

export const discordApi = {
  getGuilds: () =>
    apiRequest<{
      guilds: DiscordGuild[];
      errors: Record<string, string>;
    }>(coreClient, {
      method: 'GET',
      url: '/discord/guilds',
    }),

  getGuildMembers: (guildId: string, search?: string) =>
    apiRequest<{
      members: DiscordMember[];
      totalCount: number;
      source: string;
    }>(coreClient, {
      method: 'GET',
      url: `/discord/guilds/${guildId}/members`,
      params: search ? { search } : undefined,
    }),

  getGuildChannels: (guildId: string) =>
    apiRequest<{
      channels: DiscordChannel[];
      source: string;
    }>(coreClient, {
      method: 'GET',
      url: `/discord/guilds/${guildId}/channels`,
    }),

  getCacheStats: () =>
    apiRequest<{
      cache: {
        size: number;
        entries: string[];
      };
      botServices: Record<string, string>;
    }>(coreClient, {
      method: 'GET',
      url: '/discord/cache/stats',
    }),

  clearCache: () =>
    apiRequest<{
      success: boolean;
      message: string;
    }>(coreClient, {
      method: 'DELETE',
      url: '/discord/cache',
    }),
};

export default discordApi;
